import { FC, Suspense } from 'react';
import { Loader } from '../loading/Loader';
import { Card, CardProps } from './Card';

export const SuspenseCard: FC<CardProps> = ({ children, className, ...props }) => {
  return (
    <Suspense
      fallback={
        <Card className="flex items-center justify-center" {...props}>
          <Loader className="h-10 w-10 text-primary-800" />
        </Card>
      }
    >
      <Card className={className} {...props}>{children}</Card>
    </Suspense>
  );
};
